import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { TIndustryForm } from "@/features/learning-content/types/industryForm";
import { CardContainer } from "@/components/commons/CardContainer";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { Grid, Stack, Typography } from "@mui/material";

type TBasicInfoFormProps = {};

export const BasicInfoForm: FC<TBasicInfoFormProps> = () => {
  const { control } = useFormContext<TIndustryForm>();

  return (
    <CardContainer sx={{ borderRadius: "8px" }}>
      <Stack gap={3}>
        <Typography variant="sub16Bold" sx={{ fontSize: "20px", fontWeight: 700 }}>
          基本情報
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormField control={control} name="name" label="分野名" required>
              <Input fullWidth placeholder="入力してください" />
            </FormField>
          </Grid>

          <Grid item xs={3}>
            <Typography variant="body14" sx={{ color: "text.secondary", fontSize: "12px", mb: 0.5 }}>
              ステータス
            </Typography>
            <Typography
              variant="body14"
              sx={{
                color: "text.primary",
                fontWeight: 500,
                pb: 0.5,
                borderBottom: "1px solid",
                borderColor: "divider",
                display: "inline-block",
                width: "100%",
                minHeight: "24px",
              }}
            >
              未公開
            </Typography>
          </Grid>

          <Grid item xs={3}>
            <Typography variant="body14" sx={{ color: "text.secondary", fontSize: "12px", mb: 0.5 }}>
              有効化日
            </Typography>
            <Typography
              variant="body14"
              sx={{
                color: "text.primary",
                fontWeight: 500,
                pb: 0.5,
                borderBottom: "1px solid",
                borderColor: "divider",
                display: "inline-block",
                width: "100%",
                minHeight: "24px",
              }}
            >
              ----/--/--
            </Typography>
          </Grid>
        </Grid>
        <Stack gap={1}>
          <FormField control={control} name="internalMemo">
            <Input fullWidth placeholder="入力してください" />
          </FormField>
        </Stack>
      </Stack>
    </CardContainer>
  );
};
